/**
 * assertionsreducer.js
 * Created by calhosh on 11/6/2019.
 */

import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export function assertionsReducer(state = initialstate.assertions, action) {
	switch (action.type) {
		case types.GET_ASSERTIONS_FOR_RISKID:
			return action.response || state;
		default:
			return state;
	}
}

export function engagementAssertionsReducer(state = initialstate.engagementAssertions, action) {
	switch (action.type) {
		case types.GET_ASSERTIONS_FOR_ENGAGEMENTID:
			if (action.response) {
				return action.response || state;
			}
			break;
		default:
			return state;
	}
}

export function riskWcgwSelectionReducer(state = initialstate.riskWcgwSelection, action) {
	if (action.type === types.SET_RISKID_ASSERTIONID) {
		return {
			riskWcgw: {
				riskId: action.riskId,
				assertionId: action.assertionId
			}
		};
	} else {
		return state;
	}
}

export function assertionsFormattedForDisplay(assertions) {
	if (assertions && assertions.length > 0) {
		let assertionKnowledgeIds = assertions.map((a) => a.knowledgeAssertionId),
			emptyAssertion = {
				assertionName: '',
				assertionAbbreviation: '',
				accountId: 0,
				assertionId: 0,
				inherentRiskTypeId: 0,
				controlRiskTypeId: 0,
				hasRiskAssociated: false,
				accountName: null,
				knowledgeAssertionId: 6,
				craValue: '',
				validationStatus: null,
				validationMessages: null,
				displayOrder: 0,
				id: 0,
				notForDisplay: true
			};

		if (!assertionKnowledgeIds.some((v) => [6, 1, 10].indexOf(v) !== -1)) {
			assertions.splice(0, 0, emptyAssertion);
		}
		if (!assertionKnowledgeIds.some((v) => [7, 2, 11].indexOf(v) !== -1)) {
			assertions.splice(1, 0, emptyAssertion);
		}
		if (!assertionKnowledgeIds.some((v) => [8, 3, 12].indexOf(v) !== -1)) {
			assertions.splice(2, 0, emptyAssertion);
		}
		if (!assertionKnowledgeIds.some((v) => [4, 13].indexOf(v) !== -1)) {
			assertions.splice(3, 0, emptyAssertion);
		}
		if (!assertionKnowledgeIds.some((v) => [9, 5, 14].indexOf(v) !== -1)) {
			assertions.splice(4, 0, emptyAssertion);
		}
	}
	return assertions;
}
